"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverRouteAdditionalDistance = void 0;
class DriverRouteAdditionalDistance {
    vehicleType;
    // hour
    drivingTime;
    // km
    drivingDistance;
    // km
    aerialDistance;
    additionalPrice;
    lastYearOrdersCount;
    driverId;
    driversCount;
    closeDriversCount;
}
exports.DriverRouteAdditionalDistance = DriverRouteAdditionalDistance;
//# sourceMappingURL=DriverRouteAdditionalDistance.js.map